module.exports = __webpack_public_path__ + "static/media/home-editorial.f0e5c4b7.jpeg";